import type { AnyExtension } from '@tiptap/core';

export const getCodeBlockExtension = (): AnyExtension =>
  module.require('./CodeBlockLowlight').CodeBlock;
